"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ResizeSensor = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// from https://github.com/jehoshua02/react-resize-sensor/blob/master/ResizeSensor.js
class ResizeSensor extends _react.default.PureComponent {
  // Instance variables
  constructor(props) {
    super(props);

    _defineProperty(this, "firstCallTimer", undefined);

    _defineProperty(this, "iframeRef", undefined);

    _defineProperty(this, "handleResize", () => {
      if (this.iframeRef.current == null) return; // this approach stops react from outputing: Do not access .props of a DOM node

      const size = {
        height: this.iframeRef.current.clientHeight,
        width: this.iframeRef.current.clientWidth
      };
      window.requestAnimationFrame(() => this.props.onResize(size));
    });

    this.iframeRef = /*#__PURE__*/_react.default.createRef();
  }

  componentDidMount() {
    var _this$iframeRef$curre;

    const wait = 200; // ms

    this.firstCallTimer = window.setTimeout(this.handleResize, wait);

    if (!((_this$iframeRef$curre = this.iframeRef.current) !== null && _this$iframeRef$curre !== void 0 && _this$iframeRef$curre.contentWindow)) {
      return;
    } // there is no contentWindow in testing


    let resizeHandler = this.handleResize;

    if (this.props.debounce) {
      resizeHandler = (0, _debounce.default)(this.handleResize, wait);
    }

    this.iframeRef.current.contentWindow.addEventListener("resize", resizeHandler);
  }

  componentWillUnmount() {
    var _this$iframeRef$curre2;

    window.clearTimeout(this.firstCallTimer);
    if (!((_this$iframeRef$curre2 = this.iframeRef.current) !== null && _this$iframeRef$curre2 !== void 0 && _this$iframeRef$curre2.contentWindow)) return; // there is no contentWindow in testing

    this.iframeRef.current.contentWindow.removeEventListener("resize", this.handleResize);
  }

  render() {
    return /*#__PURE__*/_react.default.createElement("iframe", {
      title: "Resize Sensor iFrame",
      ref: this.iframeRef,
      style: {
        height: "100%",
        width: "100%",
        border: "none",
        background: "transparent",
        position: "absolute",
        zIndex: -1,
        top: 0,
        left: 0
      }
    });
  }

}

exports.ResizeSensor = ResizeSensor;

_defineProperty(ResizeSensor, "propTypes", {
  onResize: _propTypes.default.func.isRequired,
  debounce: _propTypes.default.bool
});

_defineProperty(ResizeSensor, "defaultProps", {
  debounce: false
});

var _default = ResizeSensor;
exports.default = _default;